import { useTranslation } from '../../i18n/i18n';
import HostedVerIdLogo from './VerIdLogo';

/**
 * HostedDemoBanner — Dark top banner shown when demo mode is active.
 *
 * Figma: https://www.figma.com/design/6V1D3oNy17pfFNHIRb2nmm/Ronan-V2---UX?node-id=165-14104
 * Shows "Demo environment | You are using an interactive demo of Ver.ID..."
 * Background: brand-primary (#1e3f46), text: white, shadow below.
 */
export default function HostedDemoBanner() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center gap-2.5 bg-[#1e3f46] px-6 py-3 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] w-full shrink-0">
      <HostedVerIdLogo variant="white" />
      <div className="flex items-center gap-2.5">
        <p className="text-sm font-semibold text-primary-foreground whitespace-nowrap">
          {t('demo.title')}
        </p>
        <div className="w-px self-stretch bg-primary-foreground hidden sm:block" />
        <p className="text-sm text-primary-foreground hidden sm:block">
          {t('demo.description')}
        </p>
      </div>
    </div>
  );
}
